import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/styles/index.scss";
import Home from "./Pages/Home/index";
import { Route } from "react-router-dom";
import { Routes } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import Grouping from "./Pages/Categories/index";
import Cities from "./Pages/Cities/index";
import Advertisment from "./Pages/Advertisment/Create";
import Profile from "./Pages/Profile/index";
import CheckMobile from "./Pages/Auth/CheckMobile";
import VerifyCode from "./Pages/Auth/VerifyCode";
import SignUp from "./Pages/Auth/SignUp";
import PaymentResult from "./Pages/PaymentResult/index";
import { routes } from "./Router";
import { caching } from "./Utils/functions";
import { useEffect } from "react";

function App() {

  useEffect(() => {
    caching();
  }, []);

  return <SanatBan />;
}

const SanatBan = () => {

  return (
    <div className="App" style={{ position: "relative", height: "100vh" }}>
      <BrowserRouter>
        <Routes>
          {routes.map(route => {
            return (
              <Route
                path={route.path}
                element={
                  <route.layout>
                    <route.component />
                  </route.layout>
                }
              />
            );
          })}
        </Routes>
      </BrowserRouter>
    </div>
  );
};
export default App;
